module.exports = __webpack_public_path__ + "img/img-49.c71c5e4c.png";